import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Root } from "./root";
import { authService } from "../../Auth";
import { configureStore } from "../configureStore";
import { register as registerServiceWorker } from "../serviceWorker";

export default async function startApp() {
  const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;

  const history = createBrowserHistory({ basename: baseUrl });
  const store = await configureStore(history);
  const userManager = await authService.getUserManager();

  ReactDOM.render(
    <Root history={history} store={store} userManager={userManager} />,
    document.getElementById("root")
  );

  // registerServiceWorker();
}
